import React from "react";
import mixpanel from "mixpanel-browser";
import { useAuth } from "./AuthContext";

const MixpanelContext = React.createContext(null);

export const MixpanelProvider = props => {
  const user = useAuth();

  mixpanel.init(window.MIXPANEL_TRACKER);
  //mixpanel.set_config({ debug: true });
  if (user) {
    if (user.profile) {
      const company = user.is_staff
        ? "OpenSlate"
        : user.profile.subscription
        ? user.profile.subscription.name
        : "unknown";
      mixpanel.identify(user.profile.id);
      mixpanel.people.set("company", company);
    } else {
      mixpanel.identify(user.username);
    }

    mixpanel.people.set({
      $first_name: user.first_name,
      $last_name: user.last_name,
      $email: user.email
    });
  }

  return <MixpanelContext.Provider value={mixpanel} {...props} />;
};

export const useMixpanel = () => {
  const context = React.useContext(MixpanelContext);
  if (context === undefined || context === null) {
    throw new Error(`useMixpanel must be used within a MixpanelProvider`);
  }
  return context;
};
